export enum EnvironmentOption {
  Production = "production",
  QA1 = "qa1",
  QA3 = "qa3",
  QA6 = "qa6",
}
